'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var jsxRuntime = require('react/jsx-runtime');
var styled = require('@emotion/styled');
var icons = require('@tempi/icons');
var coreRenderer = require('@tempi/core-renderer');
var index = require('../../core/Link/index.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var styled__default = /*#__PURE__*/_interopDefaultLegacy(styled);

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
const socialIconMapping = {
  facebook: {
    icon: "FacebookFilled",
    color: "#415993"
  },
  youtube: {
    icon: "YoutubeFilled",
    color: "#bd342b"
  },
  tiktok: {
    icon: "TiktokFilled",
    color: "#262626"
  },
  instagram: {
    icon: "InstagramFilled",
    color: "#d96357"
  },
  twitter: {
    icon: "TwitterFilled",
    color: "#1DA1F2"
  },
  github: {
    icon: "GithubFilled",
    color: "#000000"
  },
  zalo: { icon: "ZaloFilled", color: "#2d75f6" }
};
const SocialIcon = ({
  commonStyle,
  icons: icons$1,
  iconSize,
  iconStyle
}) => {
  return /* @__PURE__ */ jsxRuntime.jsx(Wrapper, {
    commonStyle,
    children: icons$1.map((e, index$1) => {
      var _a, _b;
      if (!socialIconMapping[e.name])
        return;
      return /* @__PURE__ */ jsxRuntime.jsx(index.Link, __spreadProps(__spreadValues({}, e.link), {
        children: /* @__PURE__ */ jsxRuntime.jsx(IconWrapper, {
          iconStyle: __spreadProps(__spreadValues({}, iconStyle), {
            height: iconStyle.width,
            backgroundColor: (_a = socialIconMapping[e.name]) == null ? void 0 : _a.color
          }),
          children: /* @__PURE__ */ jsxRuntime.jsx(icons.Icon, {
            name: (_b = socialIconMapping == null ? void 0 : socialIconMapping[e.name]) == null ? void 0 : _b.icon,
            style: { fontSize: iconSize || 25 }
          })
        })
      }), index$1);
    })
  });
};
const Wrapper = styled__default["default"].div(
  ({ commonStyle }) => `
  ${coreRenderer.getStyle(commonStyle)};
  display: flex;
`
);
const IconWrapper = styled__default["default"].div(
  ({ iconStyle }) => `
${coreRenderer.getStyle(iconStyle)};
display: flex;
align-items: center;
justify-content: center;
border-radius: 10%;
> span {
  color: white;
  line-height: 1; 
}
`
);
SocialIcon.displayName = "SocialIcon";

exports.SocialIcon = SocialIcon;
